import React from 'react';
import Header from "../../components/ui/header/navBar";
import LandingVideo from '../landing-page/main-video';
import GridContent from "../landing-page/grid-content";
import Footer from '../landing-page/footer';
// import SidebarTabs from '../landing-page/mult-tab-sidebar';
// import TabContent from '../landing-page/tab-content.tsx';
// import HoriTabContent from '../landing-page/horizontal_tab';
import '../../styles/Landing-page.scss'
import Workflow from '../landing-page/workflow.tsx';


const DefaultLandingPage: React.FC = () => {
  return (

    <>
      <Header />
      <LandingVideo />
      <GridContent />
      <Workflow />
      {/* <TabContent /> */}
      {/* <HoriTabContent /> */}
      {/* <SidebarTabs /> */}

      <Footer />
    </>
  );
}

export default DefaultLandingPage;
